import './header'
import './product'
import { register } from './Registry'

register('ak-scrollable', () => {
	document.querySelectorAll<HTMLElement>('.ak-scrollable').forEach(el => {
		const parent = el.parentNode
		if (!parent) {
			console.log('no parent found for ak-scrollable')
			return
		}

		const wrapper = document.createElement('div')
		wrapper.className = 'ak-scrollable-wrapper'

		parent.insertBefore(wrapper, el)
    	wrapper.appendChild(el)

		const leftBtn = document.createElement('button')
		leftBtn.className = 'scroll-arrow left'
		leftBtn.type = 'button'
		leftBtn.setAttribute('aria-label', 'Scroll links')
		leftBtn.hidden = true

		const rightBtn = document.createElement('button')
		rightBtn.className = 'scroll-arrow right'
		rightBtn.type = 'button'
		rightBtn.setAttribute('aria-label', 'Scroll rechts')
		rightBtn.hidden = true

		wrapper.appendChild(leftBtn)
		wrapper.appendChild(rightBtn)

		const update = () => {
			const hasOverflow = el.scrollWidth > el.clientWidth

			console.log(hasOverflow)

			if (!hasOverflow) {
				leftBtn.hidden = true
				rightBtn.hidden = true
				return
			}

			leftBtn.hidden = el.scrollLeft <= 0
			rightBtn.hidden =
				el.scrollLeft + el.clientWidth >= el.scrollWidth - 1
		}

		new ResizeObserver(update).observe(el)
		el.addEventListener('scroll', update)

		const amount = () => el.clientWidth * 0.8

		leftBtn.addEventListener('click', () => {
			el.scrollBy({ left: -amount(), behavior: 'smooth' })
		})

		rightBtn.addEventListener('click', () => {
			el.scrollBy({ left: amount(), behavior: 'smooth' })
		})

		update()
	})
})